import React from 'react';
import moment from 'moment';

import { TabMenu } from 'src/components/basic';
import SVGIcon from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import { remCss, lang, withRouter } from 'src/helpers';

import model from '../modifyModel';
import AddQuick from './Quick';
import AddBulk from './Bulk';
import AddAdvance from './Advance';
import { ImportBtn } from './Bulk';
import LANG_CONST from 'src/helpers/lang/const';

export class AddPatient extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    model.on('accountSwitched', this.init);
    this.init();
  }

  init = () => {
    model.resetState(this.props.router.params.tab);
    model.loadInit(moment());
  };

  setTab = (tab) => {
    model.handleChange('tab', tab || 'quick');
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('accountSwitched', this.init);
  }

  back = () => {
    this.navigate('/patients');
  };

  render() {
    const activeTab = model.input('tab');

    return (
      <div className={'mc-container-content mc-add-patient'}>
        <div className={'mc-container-content__header mc-flex'}>
          <div className={'mc-no-style-btn'} style={{ height: remCss(40) }} onClick={this.back}>
            <SVGIcon width={40} iconname={'back-icon'} />
          </div>
          <span className={'mc-grow'}>
            {lang.t(
              model.state.user?.isDoctor
                ? model.state.user?.clinicIds?.length > 0
                  ? LANG_CONST.titles.add_patient_to_clinic_doctor
                  : LANG_CONST.titles.add_patient_to_personal
                : LANG_CONST.titles.add_patients
            )}
          </span>
        </div>
        <div className={'mc-container-content__body'}>
          <div className={'mc-container-content__body-header'} style={{ margin: remCss(25) }}>
            <div>
              <TabMenu
                tabs={[
                  { id: 'quick', name: 'Quick' },
                  { id: 'advanced', name: 'Advanced' },
                  { id: 'bulk', name: 'Bulk' }
                ]}
                tab={{ id: activeTab }}
                type={'button'}
                setTab={(v) => {
                  model.resetApiState('bulk');
                  model.resetApiState('invite');
                  model.resetApiState('inviteAdvance');
                  model.handleChange('tab', v.id);
                  this.setTab(v.id);
                }}
              />
            </div>
            <div className={'mc-grow'} />
            {model.state.tab === 'bulk' && <ImportBtn />}
          </div>
          {model.input('tab') === 'quick' && <AddQuick />}
          {model.input('tab') === 'advanced' && <AddAdvance />}
          {model.input('tab') === 'bulk' && <AddBulk />}
        </div>
      </div>
    );
  }
}

export default withRouter(AddPatient);
